import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import * as html2pdf from 'html2pdf.js';
import * as moment from 'moment';
@Component({
  selector: 'app-propelld-pdf-generater',
  templateUrl: './propelld-pdf-generater.component.html',
  styleUrls: ['./propelld-pdf-generater.component.css']
})
export class PropelldPdfGeneraterComponent implements OnInit {
  @ViewChild('PropelldPdfTemplate') public PropelldPdfTemplate :ElementRef;
  PropelldData:any;
  dateTime = moment(new Date()).format('DD-MM-YYYY HH:mm:ss');
  constructor(private toastr: ToastrService,) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    html2pdf().from(this.PropelldPdfTemplate?.nativeElement?.innerHTML).set({
      filename: `${this.PropelldData?.emiName}_Application.pdf`,
      image: { type: 'jpeg', quality: 1 },
      margin: 0,
      pagebreak: {mode: 'legacy' },
      jsPDF: {orientation: 'portrait', unit: 'in'}
    }).save();
    setTimeout(()=>{
      this.toastr.success('The application has been downloaded',"",{
        tapToDismiss: false,
        timeOut: 5000,
        closeButton: true,
      });
    },1000)  
  }

}
